
<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0px" class="theme-container">
    <div fxFlex fxFlexAlign="center">
        <ngx-extended-pdf-viewer [src]="'assets/pdf/109-1-schedule-20200902.pdf'" [height]="'100vh'" [textLayer]="true" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>
    </div>
</div>
